import { useEffect, useReducer, useState } from "react";
import JourneyConfigTable from "./JourneyConfigTable";
import useAuthFetch from "../../hooks/useAuthFetch";
import { useLocation, useNavigate } from "react-router-dom";

export default function AllJourneyConfig() {
  const customFetch = useAuthFetch();
  const location = useLocation();
  const navigate = useNavigate();

  const [query, setQuery] = useState({});
  const [isReady, setIsReady] = useState(false);
  const [object, setObject] = useState([
    {
      label: "Template Name",
      searchFilter: "templateName",
      value: null,
    },
    {
      label: "Product Type",
      searchFilter: "productType",
      value: null,
    },
    {
      label: "Language",
      searchFilter: "language",
      value: null,
    },
    {
      searchFilter: "start",
      value: null,
    },
    {
      searchFilter: "end",
      value: null,
    },
  ]);

  // Mock equivalent to router.query and router.isReady
  useEffect(() => {
    const simulatedQuery = {};
    object.forEach((item) => {
      if (item.value !== null) {
        if (item.searchFilter === "start" || item.searchFilter === "end") {
          simulatedQuery[item.searchFilter] = new Date(item.value).toISOString();
        } else {
          simulatedQuery[item.searchFilter] = item.value;
        }
      }
    });

    // Parse existing query params from the URL
    const searchParams = new URLSearchParams(location.search);
    const existingQuery = Object.fromEntries(searchParams.entries());

    // Remove keys from `existingQuery` that have a `null` value in `object`
    Object.keys(existingQuery).forEach((key) => {
      const correspondingObjectItem = object.find((item) => item.searchFilter === key);
      if (correspondingObjectItem && correspondingObjectItem.value === null) {
        delete existingQuery[key];
      }
    });

    // Combine `existingQuery` with `simulatedQuery` and add `page=1`
    const newQuery = {
      ...existingQuery,
      ...simulatedQuery,
      page: 1, // Reset page to 1
    };

    // Filter out null or undefined values
    const filteredQuery = Object.fromEntries(
      Object.entries(newQuery).filter(([_, value]) => value !== null && value !== undefined)
    );

    // Update the state and URL
    setQuery(filteredQuery);

    const newSearch = new URLSearchParams(filteredQuery).toString();
    if (location.search !== `?${newSearch}`) {
      navigate(`${location.pathname}?${newSearch}`, { replace: true });
    }
    setIsReady(true);
    // Simulate query fetching and setting router readiness
    // const simulatedQuery = { param1: "value1", param2: "value2" }; // Replace with actual logic
    // setQuery(simulatedQuery);
    setIsReady(true);
  }, [object]);

  function reducer(state, action) {
    switch (action.type) {
      case "LOADING":
        return { ...state, isLoading: true };

      case "UPDATE":
        return { ...state, response: action.payload, isLoading: false };

      case "ERROR":
        return { ...state, response: null, isLoading: false };

      default:
        throw new Error();
    }
  }

  const [state, dispatch] = useReducer(reducer, {
    response: null,
    isLoading: false,
  });

  const handleFetch = async () => {
    if (!isReady || state.isLoading) return;

    dispatch({ type: "LOADING" });

    const url = new URL(
      `${process.env.REACT_APP_API_URL}/v1/dashboard/journeyConfig/fetchAll`
    );

    // Include query parameters with defaults for pagination
    url.search = new URLSearchParams({
      ...query,
      page: query.page || 1, // Always default to page 1 if not specified
      perPage: query.perPage || 3, // Default to 3 rows per page
    }).toString();

    try {
      const method = "GET"
      const { response, status } = await customFetch(
        url,
        method,
      );

      if (status === 200) {
        dispatch({ type: "UPDATE", payload: response });
      } else {
        dispatch({ type: "ERROR" });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: "ERROR" });
    }
  };


  const handleFetchWithPage = async(page) => {
    const updatedQuery = { ...query, page, perPage: 3 }; // Merge current query with the new page and perPage 3 param added
    const searchParams = new URLSearchParams(updatedQuery).toString();

    const url = new URL(
      `${process.env.REACT_APP_API_URL}/v1/dashboard/journeyConfig/fetchAll`
    );
    url.search = searchParams;

    dispatch({ type: "LOADING" });

    try {
      const method = "GET"
      const { response, status } = await customFetch(
        url,
        method,
      );

      if (status === 200) {
        dispatch({ type: "UPDATE", payload: response });
      } else {
        dispatch({ type: "ERROR" });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: "ERROR" });
    }
  };


useEffect(() => {
  const searchParams = new URLSearchParams(location.search);
  const updatedQuery = Object.fromEntries(searchParams.entries());

  setQuery(updatedQuery);

  // Fetch the new data based on updated query
  if (isReady) handleFetch();
}, [location.search, isReady]);

return (
  <div className="overflow-y-hidden">
    {isReady && <JourneyConfigTable reqState={state} object={object} setObject={setObject} handleFetch={handleFetch} handleFetchWithPage={handleFetchWithPage} />}
  </div>
);
}
